import { render, staticRenderFns } from "./503.vue?vue&type=template&id=6f1fd78e&scoped=true&"
import script from "./503.vue?vue&type=script&lang=js&"
export * from "./503.vue?vue&type=script&lang=js&"
import style0 from "./503.vue?vue&type=style&index=0&id=6f1fd78e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1fd78e",
  null
  
)

export default component.exports